var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('base-top-navigator-bar'),_c('v-main',{staticClass:"black"},[_vm._t("default")],2),_c('base-footer'),(_vm.$vuetify.breakpoint.smAndDown)?_c('base-bottom-navigator-bar'):_vm._e(),_c('base-snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }